/* Copyright (c) 2020-present CloudIO Inc */

import { DevProps } from 'componentregistry';
import React from 'react';

export default function Overlay(devProps: DevProps): React.ReactElement {
  return <span {...devProps} className="io-overlay" />;
}
